(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mcb-breadcrumbs"] && !Shopify.designMode) return;
  try {
    
    /* If the product has a variant sku, update the sku in the breadcrumbs */
    let variantSku = document.querySelector('[data-variant-sku]');

    if (variantSku) {
      document.addEventListener('variant:change', function (event) {
        variantSku.textContent = event.detail.variant.sku;
      });
    }
  
  } catch(e) { console.error(e); }
})();
})();
